import { PERSISTED_STATE_KEY, USER_ACCESS,
    HRIS_TOKEN_COOKIE, IDS_TOKEN_COOKIE
 } from '../config/settings';
import cookie from 'react-cookies';

export default function() {
    localStorage.removeItem(PERSISTED_STATE_KEY);
    localStorage.removeItem(USER_ACCESS);
    cookie.remove(IDS_TOKEN_COOKIE, { path: '/' });
    cookie.remove(HRIS_TOKEN_COOKIE, { path: '/' });
}
